import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useDomainConfig } from "@/contexts/DomainConfigContext";
import { useLanguage } from "@/contexts/LanguageContext";

const FAQSection = () => {
  const { config } = useDomainConfig();
  const { t } = useLanguage();
  const phoneNumber = config?.customer_service || "+44 203 9292 689";

  const faqs = [
    { question: t("faq.q1"), answer: t("faq.a1") },
    { question: t("faq.q2"), answer: t("faq.a2") },
    { question: t("faq.q3"), answer: t("faq.a3") },
    { question: t("faq.q4"), answer: t("faq.a4") },
    { question: t("faq.q5"), answer: t("faq.a5") },
    { question: t("faq.q6"), answer: t("faq.a6") },
    { question: t("faq.q7"), answer: t("faq.a7") },
    { question: t("faq.q8"), answer: t("faq.a8") },
  ];

  return (
    <section id="faq" className="py-16 md:py-24 bg-cream">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Left Side - FAQs */}
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">{t("faq.title")}</h2>
            <p className="text-muted-foreground mb-8">{t("faq.subtitle")}</p>

            <Accordion type="single" collapsible className="space-y-3">
              {faqs.map((faq, index) => (
                <AccordionItem
                  key={index}
                  value={`item-${index}`}
                  className="faq-item bg-card rounded-xl px-6 border-0 shadow-soft"
                >
                  <AccordionTrigger className="text-left font-semibold text-foreground hover:no-underline py-5">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground pb-5">{faq.answer}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>

            <div className="mt-6">
              <Link to="/faqs">
                <Button
                  variant="outline"
                  className="border-primary text-primary hover:bg-primary hover:text-primary-foreground"
                >
                  {t("faq.more")}
                </Button>
              </Link>
            </div>
          </div>

          {/* Right Side - Contact CTA */}
          <div className="lg:sticky lg:top-32">
            <div className="bg-card rounded-2xl p-8 shadow-medium text-center">
              <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-6">
                <Phone className="w-8 h-8 text-primary" />
              </div>
              <h3 className="text-2xl font-bold text-foreground mb-4">{t("faq.still")}</h3>
              <p className="text-muted-foreground mb-6">{t("faq.agents")}</p>
              <a href={`tel:${phoneNumber.replace(/\s/g, "")}`}>
                <Button className="w-full h-12 text-lg bg-accent hover:bg-accent/90 text-accent-foreground font-semibold">
                  <Phone className="w-5 h-5 ltr:mr-2 rtl:ml-2" />
                  {t("faq.call")}
                </Button>
              </a>
              <p className="text-primary font-semibold mt-4">{phoneNumber}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
